import React from 'react';
import { Tooltip, TooltipPlacement } from '@asigna/kit';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import cx from 'classnames';

import CheckedIcon from './checked.svg';
import { useCheckboxStyles } from './styles';

interface GradientCheckBoxProps extends CheckboxProps {
  disabledHint?: string | null;
  hintPosition?: TooltipPlacement;
}

export const GradientCheckBox: React.FC<GradientCheckBoxProps> = ({
  disabledHint,
  hintPosition,
  ...props
}) => {
  const classes = useCheckboxStyles();

  const CheckBoxComponent = (
    <div className={cx(classes.root, props.disabled && 'opacity-40')}>
      <Checkbox
        className={classes.component}
        icon={<span className={classes.icon} />}
        checkedIcon={<img src={CheckedIcon} className={classes.icon} alt="" />}
        {...props}
      />
    </div>
  );
  if (props.disabled && disabledHint) {
    return (
      <Tooltip content={disabledHint} position={hintPosition}>
        {CheckBoxComponent}
      </Tooltip>
    );
  }

  return CheckBoxComponent;
};
